import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  defaults,
  Filler,
  Legend,
  LinearScale,
  LogarithmicScale,
  Title,
  Tooltip,
  ArcElement,
} from "chart.js";
import React from "react";
import { Doughnut } from "react-chartjs-2";
import AppTheme from "@toothfairy/shared-ui/AppTheme";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  LogarithmicScale
);

defaults.font.family = "normalFont";
defaults.font.size = 14;
defaults.scale.ticks.precision = 0;

// Deep-merge caller options over AppDoughnut's base options so legend/tooltip
// config passed by the caller (e.g. font size, position) is actually applied.
const mergeOptions = (base, override) => {
  if (!override) return base;
  const out = { ...base };
  for (const key of Object.keys(override)) {
    const bv = base[key];
    const ov = override[key];
    if (
      bv &&
      typeof bv === "object" &&
      !Array.isArray(bv) &&
      ov &&
      typeof ov === "object" &&
      !Array.isArray(ov)
    ) {
      out[key] = mergeOptions(bv, ov);
    } else {
      out[key] = ov;
    }
  }
  return out;
};

const AppDoughnut = ({ dataset, maxHeight, options, isSumRequired }) => {
  const { currentTheme } = AppTheme.useTheme();
  const baseOptions = {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          footer: function (tooltipItem) {
            let sum = tooltipItem[0].dataset.data[tooltipItem[0].dataIndex];
            return isSumRequired ? `Cost: ${sum}€` : "";
          },
        },
      },
      legend: {
        position: "top",
        labels: {
          color: currentTheme?.theme?.font_color,
          font: {
            family: "normalFont",
            size: currentTheme?.theme?.extra_small_font_size,
          },
        },
      },
      title: {
        display: false,
        text: "Chart.js Doughnut Chart",
      },
    },
  };
  return (
    <Doughnut
      style={{
        // backgroundColor: currentTheme?.theme.softBackgroundColor,
        borderRadius: 10,
        maxHeight,
      }}
      options={mergeOptions(baseOptions, options)}
      data={dataset}
    />
  );
};

export default AppDoughnut;
